var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgService(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_278_35)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.00008 11C2.00008 11.84 1.66675 14.3333 1.66675 14.3333C1.66675 14.3333 4.16008 14 5.00008 13C5.47341 12.44 5.46675 11.58 4.94008 11.06C4.68095 10.8126 4.33961 10.6697 3.98157 10.6586C3.62352 10.6476 3.274 10.7691 3.00008 11ZM8.00008 9.99996L6.00008 7.99996C6.35484 7.07958 6.80155 6.19734 7.33341 5.36663C8.1102 4.12462 9.19183 3.10199 10.4754 2.39602C11.759 1.69005 13.2019 1.32421 14.6667 1.3333C14.6667 3.14663 14.1467 6.33329 10.6667 8.66663C9.82456 9.19891 8.93122 9.64558 8.00008 9.99996Z",
    stroke: "#006DE1",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.00008 7.99997H2.66675C2.66675 7.99997 3.03341 5.97997 4.00008 5.33331C5.08008 4.61331 7.33341 5.33331 7.33341 5.33331M8.00008 9.99997V13.3333C8.00008 13.3333 10.0201 12.9666 10.6667 12C11.3867 10.92 10.6667 8.66664 10.6667 8.66664",
    stroke: "#006DE1",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_278_35"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgService);
export default __webpack_public_path__ + "static/media/service.24ac9a78a61b2f5a01eca4485bc3fc1b.svg";
export { ForwardRef as ReactComponent };